import styled from 'styled-components'

export const Card = styled.div`
  padding: 20px;
  background-color: var(--branco);
  border-radius: 15px;
  border: 1px solid #ebebeb;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`
